module.exports = __webpack_public_path__ + "img/ctlogo1.607ebbc3.png";